module.exports = __webpack_public_path__ + "img/un.ab959d4d.svg";